import { createReducer, on } from '@ngrx/store';
import * as TaskOpportunityMetricsActions from './task-opportunity-metrics.actions';
import { TargetOpportunityMetric } from '@/models/target-opportunity-metric.model';

export interface TaskOpportunityMetricsState {
  metrics: TargetOpportunityMetric[];
  loading: boolean;
  error: any | null;
}

export const initialState: TaskOpportunityMetricsState = {
  metrics: [],
  loading: false,
  error: null,
};

export const taskOpportunityMetricsReducer = createReducer(
  initialState,
  on(TaskOpportunityMetricsActions.loadTaskOpportunityMetrics, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(TaskOpportunityMetricsActions.loadTaskOpportunityMetricsSuccess, (state, { metrics }) => ({
    ...state,
    metrics,
    loading: false,
  })),
  on(TaskOpportunityMetricsActions.loadTaskOpportunityMetricsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(TaskOpportunityMetricsActions.createTaskOpportunityMetricSuccess, (state, { metric }) => ({
    ...state,
    metrics: [...state.metrics, metric],
  })),
  on(TaskOpportunityMetricsActions.updateTaskOpportunityMetricSuccess, (state, { metric }) => ({
    ...state,
    metrics: state.metrics.map((m) => (m.id === metric.id ? metric : m)),
  })),
  on(TaskOpportunityMetricsActions.deleteTaskOpportunityMetricSuccess, (state, { metricId }) => ({
    ...state,
    metrics: state.metrics.filter((metric) => metric.id !== metricId),
  })),
  on(TaskOpportunityMetricsActions.clearTaskOpportunityMetrics, () => initialState)
);
